import React, { FC, useState } from 'react';

import { ReferralUser } from 'api-client';
import { ChevronIcon, DataTable, Money } from 'components/common';
import { formatDate } from 'formatters';
import { cn } from 'utils';

import styles from './ReferralUserTableRow.module.scss';

interface Props {
  user: ReferralUser;
}

const ReferralUserTableRow: FC<Props> = ({ user }) => {
  const [expanded, setExpanded] = useState(false);
  const transactions = user.transactions ?? [];
  const hasTransactions = transactions.length > 0;

  return (
    <div className={styles.group}>
      <DataTable.Row
        className={cn(styles.row, hasTransactions && styles.clickable)}
        onClick={() => hasTransactions && setExpanded((prev) => !prev)}
      >
        <DataTable.Cell>
          <div className={styles.name}>{user.name || '—'}</div>
          <div className={styles.phone}>{user.phone || '—'}</div>
        </DataTable.Cell>
        <DataTable.Cell className={styles.nowrap}>
          {user.registerDate ? formatDate(user.registerDate) : '—'}
        </DataTable.Cell>
        <DataTable.Cell className={styles.nowrap}>
          {user.totalUserAccrued ? '1% бессрочно' : '—'}
        </DataTable.Cell>
        <DataTable.Cell align="center">
          {hasTransactions ? transactions.length : '—'}
        </DataTable.Cell>
        <DataTable.Cell className={styles.nowrap}>
          {user.totalUserAccrued ? <Money money={user.totalUserAccrued} /> : '—'}
        </DataTable.Cell>
        <DataTable.Cell align="right">
          {hasTransactions && (
            <span className={styles.toggle}>
              <ChevronIcon
                direction={expanded ? 'down' : 'up'}
                size={20}
                color="var(--black-color)"
              />
              {expanded ? 'Свернуть' : 'Развернуть'}
            </span>
          )}
        </DataTable.Cell>
      </DataTable.Row>
      {expanded && hasTransactions && (
        <div className={styles.details}>
          <div className={styles.detailsHead}>
            <span>Инвестиция</span>
            <span>Дата</span>
            <span>Начисление</span>
          </div>
          {transactions.map((transaction) => (
            <div className={styles.detailsRow} key={transaction.uuid}>
              <span className={styles.nowrap}>
                {transaction.investedMoney && transaction.investedMoney.amount > 0 ? (
                  <Money money={transaction.investedMoney} />
                ) : (
                  '—'
                )}
              </span>
              <span className={styles.nowrap}>{formatDate(transaction.date)}</span>
              <span className={styles.nowrap}>
                <Money money={transaction.money} />
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReferralUserTableRow;
